import { observable, action, computed } from 'mobx'

import { some, includes }               from 'lodash'
import { setter }                       from 'mobx-decorators'
import axios                            from 'axios'

export class UserStore {
  @setter @observable user = null

  constructor(user) {
    this.user = user
  }

  @computed get username() {
    return this.user ? this.user.username : null
  }

  @computed get id() {
    return this.user ? this.user.id : null
  }

  @computed get modules() {
    return this.user ? this.user.modules : []
  }

  @computed get policies() {
    return this.user ? this.user.policies : []
  }

  @computed get isImpersonated() {
    return !!(this.user && this.user.impersonated)
  }

  @computed get isSpoc() {
    return !!(this.user && this.user.isSpoc)
  }

  @computed get hasLearningLab() {
    return !!(this.user && this.user.hasLearningLab)
  }

  @computed get customModules() {
    return this.user ? this.user.customModules : []
  }

  @computed get isParent() {
    return this.user ? this.user.userType === 'parent' : false
  }

  @computed get isBetaTester() {
    return this.user ? this.user.betaTester : false
  }

  @computed get hiddenModules() {
    return this.user ? this.user.hiddenModules : []
  }

  @computed get playSMSSounds() {
    return this.user ? this.user.playSmsSounds : false
  }

  @computed get hasMessageCenter() {
    const { MESSAGE_CENTER } = window.SS_MODULES

    return this.hasModules(MESSAGE_CENTER) && !(this.user && this.user.isTeacher)
  }

  @computed get hasNotify() {
    const { NOTIFY } = window.SS_MODULES

    return this.hasModules(NOTIFY) && !(this.user && this.user.isTeacher)
  }

  @computed get hasNotifyStaff() {
    const { NOTIFY_STAFF } = window.SS_MODULES

    return this.hasModules(NOTIFY_STAFF)
  }

  @computed get hasNotifyStudent() {
    // const { NOTIFY_STUDENTS } = window.SS_MODULES

    return false
  }

  @computed get canCreateGroup() {
    const {
      USER_GROUP_ADMIN,
      STUDENT_GROUP_ADMIN
    } = window.SS_MODULES

    return this.hasModules(USER_GROUP_ADMIN, STUDENT_GROUP_ADMIN)
  }

  @computed get smoreURL() {
    const url = `https://www.smore.com/login`

    return url
  }

  @computed get teachboostURL() {
    const url = `https://teachboost.com/phoenix/auth/schoolstatus/jwt?token=${window.SSUser.teachboostToken}`

    return url
  }

  @computed get customDashboards() {
    const dashboards = window.SSUser.customDashboards

    return dashboards
  }

  @computed get customSidebarDashboards() {
    const dashboards = window.SSUser.customSidebarDashboards

    return dashboards
  }

  @computed get disableClassicLogin() {
    return !!window.SSUser.disableClassicLogin
  }

  @computed get buildingLevelLeader() {
    return window.SSUser.buildingLevelLeader
  }

  @action operooAuth = async () => {
    const res = await axios.get('/operoo_auth')
    const jwt = res.data

    const html = (jwt) =>  {
      return`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Post Request Page</title>
        <script>
          window.addEventListener('DOMContentLoaded', function() {
            document.getElementById('postForm').submit();
          });
        <\/script>
      </head>
      <body>
        <form id="postForm" method="POST" action="https://app.operoo.com/users/jwt_sign_in">
          <input type="hidden" name="jwt_token" value="${jwt}">
          <input type="hidden" name="token_source" value="school_status_1">
        </form>
      </body>
      </html>
    `};

    const newTab = window.open();
    newTab.document.open();
    newTab.document.write(html(jwt));
    newTab.document.close();
  }

  @action smoreAuth = async () => {
    const res = await axios.get('/smore_auth')
    const jwt = res.data
    const smoreHost = window.location.hostname === 'secure.schoolstatus.com'
      ? 'app.smore.com'
      : 'app.staging.smore.com'

    const html = (jwt) =>  {
      return`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Post Request Page</title>
        <script>
          window.addEventListener('DOMContentLoaded', function() {
            document.getElementById('postForm').submit();
          });
        <\/script>
      </head>
      <body>
        <form id="postForm" method="POST" action="https://${smoreHost}/schoolstatus/login">
          <input type="hidden" name="jwt_token" value="${jwt}">
        </form>
      </body>
      </html>
    `};

    const newTab = window.open();
    newTab.document.open();
    newTab.document.write(html(jwt));
    newTab.document.close();
  }

  @action hasModules = (...modules) => {
    return some(modules, (m) => includes(this.modules, m))
  }

  @action hasPolicies = (...policies) => {
    return some(policies, (p) => includes(this.policies, p))
  }

  @action hasCustomModule = (module) => {
    return includes(this.customModules, module)
  }

  @action hasHiddenModule = (module) => {
    return includes(this.hiddenModules, module)
  }

  @action isConnectHighImpact = () => {
    return (window.self != window.top) || (this.hasModules('connect_high_impact'))
  }

  // Can this user broadcast from here? Mirrors the ActionBar launcher gate
  // (the broadcast_messaging module) and excludes embedded/iframe consumers.
  @computed get canBroadcast() {
    return !this.isConnectHighImpact() && this.hasModules('broadcast_messaging')
  }

  @action connectHighImpactAttachmentsEnabled = () => {
    return ['8335e029-5361-4e05-bb7e-3a46d735f133'].includes(window.SSUser.districtID)
  }
}

export default new UserStore()
